<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">工資資料</span>
        <!-- <button class="btn btn-primary btn-sm ml-2" @click="addTestData(2)">
          新增測試數據
        </button> -->
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Expenditure id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="工資編號："
                  label-for="id"
                  label-cols-md="3"
                >
                  <div class="">
                    {{
                      newExpendituresData.id
                        ? expenditureDisplayText
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- expense_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_expense_date"
                >
                  <b-form-group
                    label="出糧日期："
                    label-for="expense_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newExpendituresData.expense_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="收支者："
                  label-for="user_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="user_id"
                    v-model="newExpendituresData.user_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="salaryUsersOptions"
                    :clearable="true"
                    label="name_cn"
                    :reduce="(option) => option.id"
                    placeholder="選擇收支者"
                    :filter="userSearch"
                    @input="handleMainUserChange"
                    :disabled="user_type_id !== 1"
                  >
                    <template #option="{ roles, name_cn }">
                      <template v-if="roles && roles[0]">
                        [{{ roles[0].name }}] {{ name_cn }}
                      </template>
                      <template v-else>
                        {{ name_cn }}
                      </template>
                    </template>
                    <template #selected-option="{ roles, name_cn }">
                      <template v-if="roles && roles[0]">
                        [{{ roles[0].name }}] {{ name_cn }}
                      </template>
                      <template v-else>
                        {{ name_cn }}
                      </template>
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="計薪形式："
                  label-for="salary_type"
                  label-cols-md="3"
                >
                  <div
                    class="form-control-plaintext"
                    :class="getSalaryTypeClass(newExpendituresData.salary_type)"
                  >
                    {{ getSalaryTypeText(newExpendituresData.salary_type) }}
                  </div>
                </b-form-group>
              </b-col>
              <!-- 收款方式 -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="收款方式"
                  rules="required"
                  vid="v_salary_receive_method_id"
                >
                  <b-form-group
                    label="收款方式："
                    label-for="salary_receive_method_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="salary_receive_method_id"
                      v-model="newExpendituresData.salary_receive_method_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="salaryReceiveMethodOptions"
                      :clearable="true"
                      label="name"
                      @input="handleMainReceiveMethodChange($event)"
                      :reduce="(option) => option.id"
                      :filter="salaryReceiveMethodSearch"
                      placeholder="選擇收款方式"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- 支票號碼 -->
              <b-col
                cols="12"
                md="6"
              >
                <!-- v-if="newExpendituresData.salary_receive_method_id == 1" -->
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  :rules="newExpendituresData.salary_receive_method_id == 1 ? 'required' : ''"
                  vid="v_check_number"
                >
                  <b-form-group
                    label="支票號碼："
                    label-for="check_number"
                    label-cols-md="3"
                    :class="newExpendituresData.salary_receive_method_id == 1 ? 'required' : ''"
                  >
                    <b-form-input
                      id="check_number"
                      v-model="newExpendituresData.check_number"
                      placeholder="輸入支票號碼"
                      :disabled="newExpendituresData.salary_receive_method_id != 1"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- 出糧月份 -->
              <b-col
                md="6"
                cols="12"
                v-if="
                  newExpendituresData.salary_type === null ||
                  Number(newExpendituresData.salary_type) !== 3
                "
              >
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_month"
                >
                  <b-form-group
                    label="出糧月份："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      v-model="newExpendituresData.year_month"
                      class="form-control"
                      :config="monthPickerConfig"
                      placeholder="輸入YYYY-MM"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group
                  label="出糧備註："
                  label-for="purpose_of_expenditure"
                  label-cols-md="2"
                >
                  <b-form-textarea
                    id="purpose_of_expenditure"
                    v-model="newExpendituresData.purpose_of_expenditure"
                    placeholder="輸入出糧備註"
                    rows="3"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <h5 class="mb-0">工資詳情</h5>
                    <b-button
                      v-if="newExpendituresData.salary_records.length == 0"
                      variant="success"
                      size="sm"
                      @click="addSalaryRecord()"
                    >
                      <feather-icon size="16" icon="PlusIcon" />
                    </b-button>
                  </div>

                  <hr />
                  <div>
                    <b-row
                      v-for="(
                        record, index
                      ) in newExpendituresData.salary_records"
                      :key="`salary_record_${index}`"
                      class="px-1"
                    >
                      <b-col
                        cols="12"
                        class="d-flex backgroundColor5 mb-1 radius-round border-1"
                      >
                        <b-row class="flex-grow-1 p-2">
                          <b-col cols="12" md="6">
                            <b-row>
                              <b-col cols="12">
                                <validation-provider
                                  #default="validationContext"
                                  :vid="`v_user_id${index}`"
                                  name="此欄"
                                  rules="required"
                                >
                                  <b-form-group
                                    :label="`員工：`"
                                    :label-for="`user_id${index}`"
                                    label-cols-md="2"
                                    class="required"
                                  >
                                    <div class="w-100">
                                      <v-select
                                        v-model="record.user_id"
                                        :options="salaryUsersOptions"
                                        label="name_cn"
                                        :reduce="(option) => option.id"
                                        :filter="userSearch"
                                        :clearable="
                                          !newExpendituresData.user_id
                                        "
                                        :placeholder="
                                          newExpendituresData.user_id
                                            ? '已自動設定為主要收支者'
                                            : '選擇員工'
                                        "
                                        class="w-100"
                                        readonly
                                        disabled
                                        @input="
                                          handleSalaryRecordUserChange(
                                            record,
                                            $event
                                          )
                                        "
                                      >
                                        <template #option="{ roles, name_cn }">
                                          <template v-if="roles && roles[0]">
                                            [{{ roles[0].name }}] {{ name_cn }}
                                          </template>
                                          <template v-else>
                                            {{ name_cn }}
                                          </template>
                                        </template>
                                        <template
                                          #selected-option="{ roles, name_cn }"
                                        >
                                          <template v-if="roles && roles[0]">
                                            [{{ roles[0].name }}] {{ name_cn }}
                                          </template>
                                          <template v-else>
                                            {{ name_cn }}
                                          </template>
                                        </template>
                                      </v-select>
                                      <b-form-invalid-feedback
                                        :state="
                                          getValidationState(validationContext)
                                        "
                                      >
                                        {{ validationContext.errors[0] }}
                                      </b-form-invalid-feedback>
                                    </div>
                                  </b-form-group>
                                </validation-provider>
                              </b-col>

                              <!-- 只有當選擇了員工後才顯示工資相關欄位 -->
                              <template v-if="record.user_id">
                                <!-- salary -->
                                <b-col cols="12">
                                  <b-row class="mb-1 cal-input-group">
                                    <b-col md="2" class="label"> 工資：</b-col>
                                    <b-col md="10" class="c_content">
                                      <div
                                        class="content-wrapper d-flex align-items-center"
                                      >
                                        <!-- 日薪 -->
                                        <template
                                          v-if="
                                            newExpendituresData.salary_type !==
                                              null &&
                                            Number(
                                              newExpendituresData.salary_type
                                            ) === 1
                                          "
                                        >
                                          <validation-provider
                                            #default="validationContext"
                                            :vid="`v_working_days${index}`"
                                            name="此欄"
                                            rules="required"
                                          >
                                            <b-input-group
                                              class="group1 w-100"
                                              size="md"
                                              append="日"
                                            >
                                              <b-form-input
                                                id="working_days"
                                                v-model="record.working_days"
                                                placeholder="輸入工作日數"
                                                type="number"
                                                step="any"
                                                @input="calDayTotalSalary(record)"
                                                :state="
                                                  getValidationState(
                                                    validationContext
                                                  )
                                                "
                                              />
                                            </b-input-group>
                                          </validation-provider>

                                          <div class="operator">*</div>

                                          <validation-provider
                                            #default="validationContext"
                                            :vid="`v_worker_day_salary${index}`"
                                            name="此欄"
                                            rules="required"
                                          >
                                            <b-input-group
                                              class="group2 w-100"
                                              size="md"
                                              prepend="$"
                                              append="每日"
                                            >
                                              <b-form-input
                                                :id="`worker_day_salary${index}`"
                                                v-model="record.day_salary"
                                                type="number"
                                                step="any"
                                                placeholder="輸入每日工資"
                                                @input="calDayTotalSalary(record)"
                                                :state="
                                                  getValidationState(
                                                    validationContext
                                                  )
                                                "
                                              />
                                            </b-input-group>
                                          </validation-provider>

                                          <div class="operator">=</div>

                                          <b-input-group
                                            class="group3"
                                            size="md"
                                            prepend="$"
                                          >
                                            <b-form-input
                                              id=""
                                              type="number"
                                              step="any"
                                              v-model="record.total_salary"
                                              placeholder="0"
                                              class="bg-white"
                                              @input="handleDailySalaryTotalChange(record)"
                                            />
                                          </b-input-group>
                                        </template>

                                        <!-- 月薪或按項目 -->
                                        <template v-else>
                                          <validation-provider
                                            #default="validationContext"
                                            :vid="`v_total_salary${index}`"
                                            name="此欄"
                                            rules="required"
                                            class="w-100"
                                          >
                                            <b-input-group
                                              class="group2 w-100"
                                              size="md"
                                              prepend="$"
                                            >
                                              <!-- append="每月"-->
                                              <b-form-input
                                                :id="`total_salary${index}`"
                                                v-model="record.total_salary"
                                                type="number"
                                                step="any"
                                                :placeholder="
                                                  newExpendituresData.salary_type !==
                                                    null &&
                                                  Number(
                                                    newExpendituresData.salary_type
                                                  ) === 2
                                                    ? '輸入月薪'
                                                    : '輸入項目工資'
                                                "
                                                @input="calTotalSalary(record)"
                                                :state="
                                                  getValidationState(
                                                    validationContext
                                                  )
                                                "
                                              />
                                            </b-input-group>
                                          </validation-provider>
                                        </template>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <!-- 逾時工作 -->
                                <b-col cols="12">
                                  <b-form-group
                                    :label="`逾時工作：`"
                                    :label-for="`ot_hours${index}`"
                                    label-cols-md="2"
                                  >
                                    <b-row>
                                      <b-col cols="6">
                                        <b-input-group
                                          class="w-100"
                                          size="md"
                                          append="小時"
                                        >
                                          <b-form-input
                                            :id="`ot_hours${index}`"
                                            v-model="record.ot_hours"
                                            type="number"
                                            step="any"
                                            placeholder="輸入逾時工作時數"
                                            @input="calTotalSalary(record)"
                                          />
                                        </b-input-group>
                                      </b-col>
                                      <b-col cols="6">
                                        <b-input-group
                                          class="w-100"
                                          size="md"
                                          prepend="$"
                                        >
                                          <b-form-input
                                            :id="`ot_amount${index}`"
                                            v-model="record.ot_amount"
                                            type="number"
                                            step="any"
                                            placeholder="輸入逾時工作金額"
                                            @input="handleNumericFieldChange(record, 'ot_amount', $event)"
                                          />
                                        </b-input-group>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                </b-col>

                                <!-- 俑金/花紅 -->
                                <b-col cols="12">
                                  <b-form-group
                                    :label="`俑金/花紅：`"
                                    :label-for="`commission${index}`"
                                    label-cols-md="2"
                                  >
                                    <b-input-group
                                      class="w-100"
                                      size="md"
                                      prepend="$"
                                    >
                                      <b-form-input
                                        :id="`commission${index}`"
                                        type="number"
                                        step="any"
                                        v-model="record.commission"
                                        placeholder="輸入佣金/花紅"
                                        @input="handleNumericFieldChange(record, 'commission', $event)"
                                      />
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <!-- 其他津貼 -->
                                <b-col cols="12">
                                  <b-form-group
                                    :label="`其他津貼：`"
                                    :label-for="`allowance${index}`"
                                    label-cols-md="2"
                                  >
                                    <b-input-group
                                      class="w-100"
                                      size="md"
                                      prepend="$"
                                    >
                                      <b-form-input
                                        :id="`allowance${index}`"
                                        type="number"
                                        step="any"
                                        v-model="record.allowance"
                                        placeholder="輸入其他津貼"
                                        @input="handleNumericFieldChange(record, 'allowance', $event)"
                                        style="flex: 0 0 150px"
                                      />
                                      <b-form-input
                                        :id="`allowance_remark${index}`"
                                        type="text"
                                        v-model="record.allowance_remark"
                                        placeholder="備註"
                                        style="flex: 1 1 auto; margin-left: 8px"
                                      />
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>

                                <!-- 強積金 -->
                                <b-col cols="12">
                                  <b-form-group
                                    :label="`強積金：`"
                                    :label-for="`MPF${index}`"
                                    label-cols-md="2"
                                    class=""
                                  >
                                    <!-- class="required" -->
                                    <b-row>
                                      <b-col cols="6">
                                        <validation-provider
                                          #default="validationContext"
                                          :vid="`v_mpf_employer${index}`"
                                          name="此欄"
                                          rules=""
                                        >
                                          <!-- rules="required" -->
                                          <b-input-group
                                            class="w-100"
                                            size="md"
                                            prepend="僱主 $"
                                          >
                                            <b-form-input
                                              :id="`mpf_employer${index}`"
                                              v-model="record.mpf_employer"
                                              type="number"
                                              step="any"
                                              placeholder="輸入強積金(僱主)"
                                              @input="handleMpfFieldChange(record, 'mpf_employer', $event)"
                                              :state="
                                                getValidationState(
                                                  validationContext
                                                )
                                              "
                                            />
                                          </b-input-group>
                                        </validation-provider>
                                      </b-col>
                                      <b-col cols="6">
                                        <validation-provider
                                          #default="validationContext"
                                          :vid="`v_mpf_employee${index}`"
                                          name="此欄"
                                          rules=""
                                        >
                                          <b-input-group
                                            class="w-100"
                                            size="md"
                                            prepend="僱員 $"
                                          >
                                            <b-form-input
                                              :id="`mpf_employee${index}`"
                                              type="number"
                                              step="any"
                                              v-model="record.mpf_employee"
                                              placeholder="輸入強積金(僱員)"
                                              @input="handleMpfFieldChange(record, 'mpf_employee', $event)"
                                              :state="
                                                getValidationState(
                                                  validationContext
                                                )
                                              "
                                            />
                                          </b-input-group>
                                        </validation-provider>
                                      </b-col>
                                    </b-row>
                                  </b-form-group>
                                </b-col>
                              </template>
                              <!-- <b-col cols="12">
                                <b-form-group
                                  :label="`實際工資：`"
                                  :label-for="`actual_salary${index}`"
                                  label-cols-md="2"
                                >
                                  <b-input-group
                                    class="w-100"
                                    size="md"
                                    prepend="$"
                                  >
                                    <b-form-input
                                      :id="`actual_salary${index}`"
                                      v-model="record.actual_salary"
                                      disabled
                                      placeholder="輸入實際工資"
                                    />
                                  </b-input-group>
                                </b-form-group>
                              </b-col>-->
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="6">
                            <b-row>
                              <!-- 發票選擇 - 只有非月薪才顯示 -->
                              <b-col
                                cols="12"
                                v-if="
                                  newExpendituresData.salary_type !== null &&
                                  Number(newExpendituresData.salary_type) !== 2
                                "
                              >
                                <b-form-group
                                  :label="`選擇發票：`"
                                  :label-for="`invoice_id${index}`"
                                  label-cols-md="2"
                                >
                                  <v-select
                                    :id="`invoice_id${index}`"
                                    v-model="record.invoice_id"
                                    :dir="
                                      $store.state.appConfig.isRTL
                                        ? 'rtl'
                                        : 'ltr'
                                    "
                                    :options="invoiceOptions"
                                    :clearable="true"
                                    label="invoice_number"
                                    :reduce="(option) => option.id"
                                    placeholder="選擇發票"
                                  >
                                    <template
                                      #option="{
                                        invoice_number,
                                        name_cn,
                                        address,
                                      }"
                                    >
                                      [{{ invoice_number }}]
                                      {{ name_cn || "未指定客戶"
                                      }}{{ address ? " " + address : "" }}
                                    </template>
                                    <template
                                      #selected-option="{
                                        invoice_number,
                                        name_cn,
                                        address,
                                      }"
                                    >
                                      [{{ invoice_number }}]
                                      {{ name_cn || "未指定客戶"
                                      }}{{ address ? " " + address : "" }}
                                    </template>
                                  </v-select>
                                </b-form-group>
                              </b-col>

                              <b-col cols="12">
                                <b-form-group
                                  :label="`備註：`"
                                  :label-for="`remark${index}`"
                                  label-cols-md="2"
                                >
                                  <b-form-textarea
                                    v-model="record.remark"
                                    placeholder="輸入備註"
                                    rows="2"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <!-- 只有日薪才顯示新增/刪除按鈕 -->
                        <div
                          class="d-flex flex-column justify-content-between py-50 px-25"
                          v-if="isDailySalaryType"
                        >
                          <feather-icon
                            size="16"
                            icon="PlusIcon"
                            class="cursor-pointer text-success"
                            @click="addSalaryRecord(index)"
                          />
                          <feather-icon
                            size="16"
                            icon="XIcon"
                            class="cursor-pointer text-danger"
                            @click="removeSalaryRecord(index, record.id)"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </div>

                  <!-- 日薪匯總卡片 -->
                  <div
                    v-if="newExpendituresData.salary_type === 1 && dailySalarySummary"
                    class=""
                  >
                    <b-card
                      class="salary-summary-card"
                    >
                      <template #header>
                        <h6 class="mb-0 font-weight-bold">
                          <feather-icon size="16" icon="BarChart3Icon" class="mr-1" />
                          工資匯總
                        </h6>
                      </template>

                      <b-row>
                        <b-col cols="12" md="6">
                          <div class="summary-item mb-2">
                            <span class="summary-label">總逾時工作金額：</span>
                            <span class="summary-value font-weight-bold">
                              {{ formatCurrency(dailySalarySummary.totalOtAmount) }}
                            </span>
                          </div>
                          <div class="summary-item mb-2">
                            <span class="summary-label">總佣金/花紅：</span>
                            <span class="summary-value font-weight-bold">
                              {{ formatCurrency(dailySalarySummary.totalCommission) }}
                            </span>
                          </div>
                          <div class="summary-item mb-2">
                            <span class="summary-label">總其他津貼：</span>
                            <span class="summary-value font-weight-bold">
                              {{ formatCurrency(dailySalarySummary.totalAllowance) }}
                            </span>
                          </div>
                        </b-col>
                        <b-col cols="12" md="6">
                          <div class="summary-item mb-2">
                            <span class="summary-label">總僱主強積金：</span>
                            <span class="summary-value font-weight-bold">
                              {{ formatCurrency(dailySalarySummary.totalMpfEmployer) }}
                            </span>
                          </div>
                          <div class="summary-item mb-2">
                            <span class="summary-label">總僱員強積金：</span>
                            <span class="summary-value font-weight-bold">
                              {{ formatCurrency(dailySalarySummary.totalMpfEmployee) }}
                            </span>
                          </div>
                        </b-col>
                      </b-row>
                          <hr />
                          <div class="summary-item">
                            <span class="summary-label">總工資金額：</span>
                            <span class="summary-value font-weight-bold text-primary">
                              {{ formatCurrency(dailySalarySummary.totalSalary) }}
                            </span>
                          </div>
                          <!-- <div class="summary-item">
                            <span class="summary-label">總實發工資：</span>
                            <span class="summary-value font-weight-bold text-success">
                              {{ formatCurrency(dailySalarySummary.totalActualSalary) }}
                            </span>
                          </div> -->
                    </b-card>
                  </div>
                </div>
              </b-col>

              <b-col
                cols="12"
                md="12"
                v-if="ability.can('status', 'expenditure_form')"
              >
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_expense_status_id"
                >
                  <b-form-group
                    label="工資狀態："
                    label-for="expense_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="expense_status_id"
                      v-model="newExpendituresData.expense_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="expenseStatusOptions"
                      label="name"
                      :reduce="(option) => option.id"
                      :filter="expenseStatusSearch"
                      placeholder="選擇工資狀態"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_actual_salary"
                >
                  <b-form-group
                    label="總實發工資："
                    label-for="actual_salary"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="actual_salary"
                      :value="newExpendituresData.actual_salary"
                      placeholder="輸入總實發工資"
                      :disabled="true"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_total_amount"
                >
                  <b-form-group
                    label="公司總支出金額："
                    label-for="total"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="total_amount"
                      :value="newExpendituresData.total_amount"
                      placeholder="輸入公司總支出金額"
                      :disabled="true"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <label
              >PS. 總實發工資 = 各項工資 + 各項佣金/花紅 +
              各項其他津貼 + 各項逾時工作金額 - 各項強積金(僱員)</label
            >
            <div>
            <label
              >PS. 公司總支出金額 = 各項工資 + 各項佣金/花紅 +
              各項其他津貼 + 各項逾時工作金額 + 各項強積金(僱主)</label
            >
          </div>

            <hr />

            <upload-file
              key="fileupload1"
              ref="childRef1"
              custome_id="1"
              :props_previewImage="newExpendituresData.documents"
              file_delete_url="/finance/expenditures/documents"
              v-on:file-uploaded="onFileUploaded"
            ></upload-file>

            <hr />

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea,
  BInputGroup,
  BCard,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import ability from "@/libs/acl/ability";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { months } from "@/libs/helper";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  data() {
    return {
      months,
      required,
      ability,
      user_type_id: JSON.parse(localStorage.getItem("userData")).user_type_id,
      image_files: [],
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BCard,
    flatPickr,
    vSelect,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  methods: {
    monthSelectPlugin,
    onFileUploaded(files) {
      this.image_files = files;
    },
    addTestData(type) {
      if (type === 2) {
        this.newExpendituresData = {
          check_number: "12345678",
          expense_date: "2025-08-08",
          expense_status_id: 4,
          id: 0,
          invoice_id: null,
          purpose_of_expenditure: "test \n月薪",
          salary_receive_method_id: 1,
          salary_records: [
            {
              id: 0,
              user_id: 15,
              total_salary: 25000,
            },
          ],
          salary_type: 2,
          total_amount: 26300,
          user_id: 15,
        };
      }
    },
    // handleUserChange(record, userId) {
    //   if (!userId) {
    //     // 如果沒有選擇用戶，清空所有相關欄位
    //     this.$set(record, 'working_date', null);
    //     this.$set(record, 'year_month', null);
    //     // salary_type 現在在主表單層級管理
    //     return;
    //   }

    //   // 查找選擇的用戶
    //   const selectedUser = this.salaryUsersOptions.find(user => user.id === userId);
    //   if (!selectedUser) return;

    //   // salary_type 現在在主表單層級根據用戶的 payment_method_id 設置
    //   if (selectedUser.payment_method_id) {
    //     // 先清空所有相關欄位
    //     this.$set(record, 'working_date', null);
    //     this.$set(record, 'year_month', null);
    //     this.$set(record, 'day_salary', 0);
    //     this.$set(record, 'working_days', 0);
    //     this.$set(record, 'total_salary', 0);

    //     // 創建一個新的 record 對象，以確保 Vue 能夠檢測到變化
    //     const newRecord = {...record};

    //     // salary_type 現在在主表單層級管理

    //     // 月薪記錄現在使用主表單的出糧月份

    //     // 將新的 record 對象的屬性複製回原始 record 對象
    //     Object.keys(newRecord).forEach(key => {
    //       this.$set(record, key, newRecord[key]);
    //     });

    //     // 使用 nextTick 確保在 DOM 更新後執行
    //     this.$nextTick(() => {
    //       // 強制更新組件，確保界面反映最新狀態
    //       this.$forceUpdate();

    //       // 輸出日誌，幫助調試
    //       console.log('salary_type 現在在主表單層級管理');
    //     });
    //   }
    // },
    actualSalary(record) {
      return (
        Math.round(
          (Number(record.total_salary) || 0) +
            (Number(record.commission) || 0) +
            (Number(record.allowance) || 0) +
            (Number(record.ot_salary) || 0) -
            (Number(record.mpf_employee) || 0)
        ) / 10
      );
    },
    handleMainReceiveMethodChange(event) {
      if(event != 1){
        this.$set(this.newExpendituresData, "check_number", null);
      }
    },
    handleSalaryNull(record){
      // 處理強積金欄位的空值轉換
      if (record.mpf_employer === "" || record.mpf_employer === undefined) {
        this.$set(record, "mpf_employer", null);
      }
      if (record.mpf_employee === "" || record.mpf_employee === undefined) {
        this.$set(record, "mpf_employee", null);
      }

      // 處理其他可選欄位的空值轉換
      if (record.ot_hours === "" || record.ot_hours === undefined) {
        this.$set(record, "ot_hours", null);
      }
      if (record.ot_amount === "" || record.ot_amount === undefined) {
        this.$set(record, "ot_amount", null);
      }
      if (record.commission === "" || record.commission === undefined) {
        this.$set(record, "commission", null);
      }
      if (record.allowance === "" || record.allowance === undefined) {
        this.$set(record, "allowance", null);
      }
    },
    calDayTotalSalary (record) {  
      if (record.working_days && record.day_salary) {
        const calculatedSalary =
          Math.round(
            Number(record.working_days) * Number(record.day_salary) * 10
          ) / 10;
        this.$set(record, "total_salary", calculatedSalary);
      }
      this.handleSalaryNull(record);
      this.calTotalAmount();
      this.calActualSalary();
    },
    calTotalSalary(record) {
      // this.$set(record, "total_salary", Number(record.total_salary));
      this.handleSalaryNull(record);
      this.calTotalAmount();
      this.calActualSalary();
    },
    hide() {
      if (this.$route.name.indexOf("salary") > -1) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/expenditure/list");
      }
    },
    userSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase()) || item.roles[0].name.toLowerCase().includes(search.toLowerCase());
      });
      return returnOptions;
    },
    salaryReceiveMethodSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    expenseStatusSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      // 將前端虛擬字段 year_month 轉換為後端需要的 salary_year 和 salary_month
      console.log('this.newExpendituresData', this.newExpendituresData)

      // 檢查是否為項目計薪形式（salary_type = 3）
      if (this.newExpendituresData.salary_type === 3 || Number(this.newExpendituresData.salary_type) === 3) {
        // 項目計薪形式不需要 salary_year 和 salary_month
        this.newExpendituresData.salary_year = null;
        this.newExpendituresData.salary_month = null;
      } else {
        // 其他計薪形式需要處理 year_month
        if (typeof this.newExpendituresData.year_month == "string") {
          // 處理 "2025-7" 或 "2025-07" 格式
          const [month, year ] = this.newExpendituresData.year_month.split(" ");
          this.newExpendituresData.salary_year = parseInt(year);
          this.newExpendituresData.salary_month = months.indexOf(month)+1;
        } else if (this.newExpendituresData.year_month instanceof Date) {
          this.newExpendituresData.salary_year = this.newExpendituresData.year_month.getFullYear();
          this.newExpendituresData.salary_month = this.newExpendituresData.year_month.getMonth() + 1;
        }
      }

      // 移除虛擬字段，避免提交到後端
      const submitData = { ...this.newExpendituresData };
      delete submitData.year_month;

      // 對於項目計薪形式，完全移除 salary_year 和 salary_month 字段
      if (submitData.salary_type === 3 || Number(submitData.salary_type) === 3) {
        delete submitData.salary_year;
        delete submitData.salary_month;
      }

      // 創建 FormData 對象
      const formData = new FormData();

      // 添加基本表單資料
      Object.keys(submitData).forEach(key => {
        if (key === 'salary_records') {
          // 跳過 salary_records，因為會單獨處理
        } else if (key === 'documents') {
          // 跳過 documents，因為檔案會單獨處理
        } else if (key === 'user' || key === 'salary_receive_method' || key === 'actual_salary' || key === 'created_at' || key === 'updated_at') {
          // 跳過這些不需要提交的欄位
        } else if (key === 'expense_date') {
          // 特殊處理 expense_date：添加當前時間
          if (submitData[key]) {
            const dateValue = submitData[key];
            // 如果只有日期部分（格式：YYYY-MM-DD），添加當前時間
            if (dateValue.length === 10) {
              const now = new Date();
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              formData.append(key, `${dateValue} ${hours}:${minutes}:${seconds}`);
            } else {
              formData.append(key, dateValue);
            }
          }
        } else if (key === 'is_approved') {
          // 特殊處理布爾值：轉換為 0 或 1
          formData.append(key, submitData[key] ? 1 : 0);
        } else if (submitData[key] !== null && submitData[key] !== undefined) {
          formData.append(key, submitData[key]);
        }
      });

      // 處理 salary_records 陣列 - 使用與報銷表單相同的方式
      if (this.newExpendituresData.salary_records && this.newExpendituresData.salary_records.length > 0) {
        // 定義 salary_records 表允許的欄位
        const allowedSalaryFields = [
          'id', 'expense_id', 'prepayment_id', 'claim_id', 'salary_summary_id',
          'user_id', 'invoice_id', 'project_id', 'working_days', 'day_salary',
          'is_monthly', 'ot_hours', 'ot_amount', 'mpf_employer', 'mpf_employee',
          'commission', 'allowance', 'allowance_remark', 'total_salary', 'remark',
          'is_approved', 'is_rejected', 'admin_remark', 'approve_date'
        ];

        for (let i = 0; i < this.newExpendituresData.salary_records.length; i++) {
          const salaryRecord = this.newExpendituresData.salary_records[i];
          for (let key of allowedSalaryFields) {
            if (salaryRecord.hasOwnProperty(key)) {
              const value = salaryRecord[key];
              formData.append(
                `salary_records[${i}][${key}]`,
                value !== undefined && value !== null ? value : ''
              );
            }
          }
        }
      }

      // 添加檔案 - 使用與報銷表單相同的方式
      if (this.image_files && this.image_files.length > 0) {
        this.image_files.forEach((item) => {
          formData.append("documents[]", item);
        });
      }

      console.log('FormData prepared for submission');
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
           store
            .dispatch("expenditures/editExpenditure", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetech-data");
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    addSalaryRecord(index) {
      if (!this.newExpendituresData.salary_records) {
        this.newExpendituresData.salary_records = [];
      }
      const newItem = JSON.parse(
        JSON.stringify({
          id: 0,
          user_id: this.newExpendituresData.user_id || null, // 自動設定為主要收支者
          invoice_id: null,
          day_salary: 0,
          total_salary: 0,
          ot_hours: null,
          ot_amount: null,
          commission: null,
          allowance: null,
          allowance_remark: "",
          mpf_employer: null,
          mpf_employee: null,
          remark: "",
        })
      );

      // 如果有主要收支者，觸發用戶變更邏輯以設定相關欄位
      if (newItem.user_id) {
        this.handleSalaryRecordUserChange(newItem, newItem.user_id);
      }

      if (index !== undefined) {
        this.newExpendituresData.salary_records.splice(index + 1, 0, newItem);
      } else {
        this.newExpendituresData.salary_records.push(newItem);
      }
    },
    getSalaryTypeText(salaryType) {
      if (salaryType == null) {
        return "請選擇收支者以決定計薪形式";
      }

      // 檢查當前用戶的計薪方式是否與 salary_type 一致
      if (this.newExpendituresData.user_id && this.userOptions) {
        const selectedUser = this.userOptions.find(
          (user) => user.id === this.newExpendituresData.user_id
        );
        if (selectedUser && selectedUser.payment_method_id !== salaryType) {
          const currentTypeName = this.getPaymentMethodName(salaryType);
          const userTypeName = this.getPaymentMethodName(
            selectedUser.payment_method_id
          );
          return `${currentTypeName}，該用戶已修改計薪形式為${userTypeName}`;
        }
      }

      // 正常顯示
      return this.getPaymentMethodName(salaryType);
    },
    getPaymentMethodName(methodId) {
      switch (Number(methodId)) {
        case 1:
          return "日薪";
        case 2:
          return "月薪";
        case 3:
          return "以工程項目計算";
        default:
          return "未知";
      }
    },
    getSalaryTypeClass(salaryType) {
      if (salaryType == null) {
        return "text-muted";
      }

      // 檢查當前用戶的計薪方式是否與 salary_type 一致
      if (this.newExpendituresData.user_id && this.userOptions) {
        const selectedUser = this.userOptions.find(
          (user) => user.id === this.newExpendituresData.user_id
        );
        if (selectedUser && selectedUser.payment_method_id !== salaryType) {
          return "text-warning";
        }
      }

      return "text-success";
    },
    removeSalaryRecord(index) {
      // if (
      //   this.newExpendituresData.salary_records.length > 1
      // ) {
      this.newExpendituresData.salary_records.splice(index, 1);
      this.calTotalAmount();
      this.calActualSalary();
      // } else {
      //   this.$swal({
      //     // title: "你確定嗎?",
      //     text: "至少要留有一個工資項目",
      //     icon: "warning",
      //     confirmButtonText: "確定",
      //     customClass: {
      //       confirmButton: "btn btn-primary",
      //     },
      //   });
      // }
    },
  },
  props: {
    expendituresData: {
      type: Object,
      required: true,
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    workerOptions: {
      type: Array,
      required: true,
    },
    approvalStatusOptions: {
      type: Array,
      required: true,
    },
    expenseStatusOptions: {
      type: Array,
      required: true,
    },

    userOptions: {
      type: Array,
      required: true,
    },
    salaryReceiveMethodOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newExpendituresData = ref({
      id: 0,
      salary_records: [{ id: 0 }],
      user_id: null,
      salary_type: null, // 初始為 null，等待用戶選擇收支者後自動設定
      salary_receive_method_id: null,
      check_number: null,
      year_month: null,
      documents: [],
    });

    const salaryUsersOptions = computed(() => {
      return props.userOptions.filter(
        (user) => user.user_type_id == 1 || user.user_type_id == 4
      );
    });

    // 判斷是否為日薪類型（用於控制新增/刪除按鈕顯示）
    const isDailySalaryType = computed(() => {
      // 直接檢查主表單的 salary_type，null 時默認為 false
      return (
        newExpendituresData.value.salary_type !== null &&
        Number(newExpendituresData.value.salary_type) === 1
      );
    });

    // 內部函數：處理工資記錄中的用戶變更邏輯
    const handleSalaryRecordUserChange = (record, userId) => {
      // 查找選擇的用戶
      const selectedUser = salaryUsersOptions.value.find(
        (user) => user.id === userId
      );
      if (!selectedUser) return;

      // 只有在新建記錄時才清空相關欄位，編輯模式下保留現有數據
      const isNewRecord = !record.id || record.id === 0;

      if (isNewRecord) {
        // 先清空所有相關欄位
        record.day_salary = 0;
        record.working_days = 0;
        record.total_salary = 0;
      }
    };

    const handleMainUserChange = (userId) => {
      if (userId) {
        const selectedUser = props.userOptions.find(
          (user) => user.id === userId
        );
        if (selectedUser) {
          // 只有在新建模式下才根據用戶的 payment_method_id 自動更新 salary_type
          if (selectedUser.payment_method_id && newExpendituresData.value.id === 0) {
            newExpendituresData.value.salary_type = Number(
              selectedUser.payment_method_id
            );
          }

          // 自動設定工資記錄中的員工為相同的收支者
          if (
            newExpendituresData.value.salary_records &&
            newExpendituresData.value.salary_records.length > 0
          ) {
            newExpendituresData.value.salary_records.forEach((record) => {
              // 只更新用戶ID，不觸發數據重置（編輯模式下保留現有數據）
              record.user_id = userId;

              // 只在新建記錄時才觸發用戶變更邏輯
              const isNewRecord = !record.id || record.id === 0;
              if (isNewRecord) {
                handleSalaryRecordUserChange(record, userId);
              }
            });
          }
        }
      } else {
        // 如果清空主要收支者，只有在新建模式下才重置 salary_type 為 null
        if (newExpendituresData.value.id === 0) {
          newExpendituresData.value.salary_type = null;
        }

        // 如果清空主要收支者，也清空工資記錄中的員工選擇
        if (
          newExpendituresData.value.salary_records &&
          newExpendituresData.value.salary_records.length > 0
        ) {
          newExpendituresData.value.salary_records.forEach((record) => {
            record.user_id = null;
            // 清空相關欄位
            handleSalaryRecordUserChange(record, null);
          });
        }
      }
    };

    watch(
      () => props.expendituresData,
      (newVal) => {
        const oldUserId = newExpendituresData.value.user_id;

        // 使用 Object.assign 避免丟失響應式綁定
        Object.assign(newExpendituresData.value, newVal);

        // 確保主表單的 salary_type 正確設置
        // 只有在新建模式下且 salary_type 為空時才自動設置
        if (
          !newExpendituresData.value.salary_type &&
          newExpendituresData.value.user_id &&
          props.userOptions &&
          newExpendituresData.value.id === 0  // 只在新建模式下自動設置
        ) {
          const selectedUser = props.userOptions.find(
            (user) => user.id === newExpendituresData.value.user_id
          );
          if (selectedUser && selectedUser.payment_method_id) {
            newExpendituresData.value.salary_type = Number(
              selectedUser.payment_method_id
            );
          }
        }

        newExpendituresData.value.total_amount = newExpendituresData.value
          .total_amount
          ? Math.round(Number(newExpendituresData.value.total_amount) * 10) / 10
          : 0;

        // 初始化實發工資
        if (!newExpendituresData.value.actual_salary) {
          newExpendituresData.value.actual_salary = 0;
        }

        // 重新計算實發工資
        calActualSalary();

        //如果是新建模式且沒有設置用戶，設置當前登入用戶為預設報銷者
        if (
          newExpendituresData.value.id === 0 &&
          !newExpendituresData.value.user_id
        ) {
          const currentUser = JSON.parse(localStorage.getItem("userData"));
          if (currentUser && currentUser.id) {
            newExpendituresData.value.user_id = currentUser.id;
            // 觸發 handleMainUserChange 邏輯來設置相關字段
            handleMainUserChange(currentUser.id);
          }
        }

        // 檢查是否有新的 user_id 需要處理（例如來自URL參數）
        if (
          newExpendituresData.value.user_id &&
          newExpendituresData.value.user_id !== oldUserId
        ) {
          // 觸發 handleMainUserChange 邏輯
          handleMainUserChange(newExpendituresData.value.user_id);
        }
      }
    );

    // 監聽用戶選項的變化，確保主表單的 salary_type 正確設置
    // 只有在新建模式下才自動設置 salary_type
    watch(
      () => [props.userOptions, newExpendituresData.value.user_id],
      ([userOptions, userId]) => {
        if (
          userOptions &&
          userOptions.length > 0 &&
          userId &&
          !newExpendituresData.value.salary_type &&
          newExpendituresData.value.id === 0  // 只在新建模式下自動設置
        ) {
          const selectedUser = userOptions.find((user) => user.id === userId);
          if (selectedUser && selectedUser.payment_method_id) {
            newExpendituresData.value.salary_type = Number(
              selectedUser.payment_method_id
            );
            console.log(
              "設定主表單的 salary_type:",
              newExpendituresData.value.salary_type,
              "用戶:",
              selectedUser.name_cn
            );
          }
        }
      },
      { immediate: true, deep: true }
    );

    // 監聽主要收支者變化，自動同步到工資記錄
    watch(
      () => newExpendituresData.value.user_id,
      (newUserId, oldUserId) => {
        // 只有當用戶ID真正改變時才執行
        if (
          newUserId !== oldUserId &&
          newExpendituresData.value.salary_records
        ) {
          if (newUserId) {
            // 自動設定工資記錄中的員工為相同的收支者
            newExpendituresData.value.salary_records.forEach((record) => {
              if (!record.user_id || record.user_id !== newUserId) {
                record.user_id = newUserId;

                // 只在新建記錄時才觸發用戶變更邏輯
                const isNewRecord = !record.id || record.id === 0;
                if (isNewRecord) {
                  handleSalaryRecordUserChange(record, newUserId);
                }
              }
            });
          }
        }
      }
    );

    const resetExpendituresData = () => {
      newExpendituresData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          salary_records: [],
          user_id: null,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } = formValidation(
      resetExpendituresData
    );

    const calTotalAmount = () => {
      let amount = 0;
      if (
        newExpendituresData.value.salary_records &&
        newExpendituresData.value.salary_records.length > 0
      ) {
        amount += newExpendituresData.value.salary_records.reduce(
          (a, b) =>
            a +
            (Number(b.total_salary) ? Number(b.total_salary) : 0) +
            (Number(b.commission) ? Number(b.commission) : 0) +
            (Number(b.allowance) ? Number(b.allowance) : 0) +
            (Number(b.ot_amount) ? Number(b.ot_amount) : 0) +
            (Number(b.mpf_employer) ? Number(b.mpf_employer) : 0),
          0
        );
        //
      }
      newExpendituresData.value.total_amount =
        Math.round(Number(amount) * 10) / 10;
    };

    // 計算實發工資
    const calActualSalary = () => {
      let actualAmount = 0;
      if (
        newExpendituresData.value.salary_records &&
        newExpendituresData.value.salary_records.length > 0
      ) {
        actualAmount += newExpendituresData.value.salary_records.reduce(
          (a, b) =>
            a +
            (Number(b.total_salary) ? Number(b.total_salary) : 0) +
            (Number(b.commission) ? Number(b.commission) : 0) +
            (Number(b.allowance) ? Number(b.allowance) : 0) +
            (Number(b.ot_amount) ? Number(b.ot_amount) : 0) -
            (Number(b.mpf_employee) ? Number(b.mpf_employee) : 0),
          0
        );
      }
      newExpendituresData.value.actual_salary =
        Math.round(Number(actualAmount) * 100) / 100;
    };

    // 處理日薪 total_salary 手動輸入的變更
    const handleDailySalaryTotalChange = (record) => {
      // 確保 total_salary 是數字
      if (record.total_salary !== null && record.total_salary !== undefined && record.total_salary !== '') {
        record.total_salary = Number(record.total_salary);
      }

      // 處理空值轉換
      if (record.mpf_employer === "" || record.mpf_employer === undefined) {
        record.mpf_employer = null;
      }
      if (record.mpf_employee === "" || record.mpf_employee === undefined) {
        record.mpf_employee = null;
      }

      // 重新計算總金額和實發工資
      calTotalAmount();
      calActualSalary();

      // 強制觸發響應式更新
      newExpendituresData.value = { ...newExpendituresData.value };
    };

    // 處理強積金欄位變更的響應式更新
    const handleMpfFieldChange = (record, fieldName, value) => {
      // 確保值是數字或 null
      if (value !== null && value !== undefined && value !== '') {
        record[fieldName] = Number(value);
      } else {
        record[fieldName] = null;
      }

      // 重新計算總金額和實發工資
      calTotalAmount();
      calActualSalary();

      // 強制觸發響應式更新
      newExpendituresData.value = { ...newExpendituresData.value };
    };

    // 處理其他數值欄位變更的響應式更新（commission, allowance, ot_amount）
    const handleNumericFieldChange = (record, fieldName, value) => {
      // 確保值是數字或 null
      if (value !== null && value !== undefined && value !== '') {
        record[fieldName] = Number(value);
      } else {
        record[fieldName] = null;
      }

      // 重新計算總金額和實發工資
      calTotalAmount();
      calActualSalary();

      // 強制觸發響應式更新
      newExpendituresData.value = { ...newExpendituresData.value };
    };

    // 計算日薪匯總數據
    const dailySalarySummary = computed(() => {
      if (!newExpendituresData.value.salary_records || newExpendituresData.value.salary_records.length <= 1) {
        return null;
      }

      const records = newExpendituresData.value.salary_records;

      const totalOtAmount = records.reduce((sum, record) => sum + (Number(record.ot_amount) || 0), 0);
      const totalCommission = records.reduce((sum, record) => sum + (Number(record.commission) || 0), 0);
      const totalAllowance = records.reduce((sum, record) => sum + (Number(record.allowance) || 0), 0);
      const totalMpfEmployer = records.reduce((sum, record) => sum + (Number(record.mpf_employer) || 0), 0);
      const totalMpfEmployee = records.reduce((sum, record) => sum + (Number(record.mpf_employee) || 0), 0);
      const totalSalary = records.reduce((sum, record) => sum + (Number(record.total_salary) || 0), 0);

      // 計算總實發工資
      const totalActualSalary = totalSalary + totalCommission + totalOtAmount + totalAllowance - totalMpfEmployee;

      return {
        totalOtAmount,
        totalCommission,
        totalAllowance,
        totalMpfEmployer,
        totalMpfEmployee,
        totalSalary,
        totalActualSalary
      };
    });

    // 格式化金額為 HK$ 格式
    const formatCurrency = (amount) => {
      return `HK$${Number(amount || 0).toFixed(2)}`;
    };

    // 格式化實發工資顯示
    // const formattedActualSalary = computed(() => {
    //   return formatCurrency(newExpendituresData.value.actual_salary);
    // });

    // // 格式化總支出金額顯示
    // const formattedTotalAmount = computed(() => {
    //   return formatCurrency(newExpendituresData.value.total_amount);
    // });

   const monthPickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: 'Y-m',
      dateFormat: 'Y-m',
      plugins: [monthSelectPlugin()],
      enableTime: false,
      static: true,
    }

    // 不用了
    const multiDatePickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: "Y-m-d",
      mode: "multiple",
      dateFormat: "Y-m-d",
      static: false,
      plugins: [],
    };

    // 不用了
    const rangeDatePickerConfig = {
      allowInput: true,
      altInput: true,
      altFormat: "Y-m-d",
      mode: "range",
      dateFormat: "Y-m-d",
      static: false,
      plugins: [],
    };

    // 動態生成支出顯示文字 - 使用 computed 屬性以便響應數據變化
    const expenditureDisplayText = computed(() => {
      if (!newExpendituresData.value.expense_number) {
        return "系統自動生成";
      }

      let displayText = newExpendituresData.value.expense_number;

      // 根據不同的支出類型添加相關名稱信息
      const expenseNumber = newExpendituresData.value.expense_number;

      // 薪金支出類型 (H開頭) - 主要處理的類型
      if (expenseNumber && expenseNumber.startsWith("H")) {
        // 獲取收支者姓名
        if (
          newExpendituresData.value.user_id &&
          props.userOptions &&
          props.userOptions.length > 0
        ) {
          const selectedUser = props.userOptions.find(
            (user) => user.id === newExpendituresData.value.user_id
          );
          if (selectedUser && selectedUser.name_cn) {
            displayText += ` - ${selectedUser.name_cn}`;
          }
        }
      }
      // 收據類型 (R開頭)
      else if (expenseNumber && expenseNumber.startsWith("R")) {
        // 獲取客戶名稱（通過發票）
        if (
          newExpendituresData.value.invoice_id &&
          props.invoiceOptions &&
          props.invoiceOptions.length > 0
        ) {
          const selectedInvoice = props.invoiceOptions.find(
            (invoice) => invoice.id === newExpendituresData.value.invoice_id
          );
          if (selectedInvoice && selectedInvoice.name_cn) {
            displayText += ` - ${selectedInvoice.name_cn}`;
          }
        }
      }
      // 報銷支出類型 (CL開頭)
      else if (expenseNumber && expenseNumber.startsWith("CL")) {
        // 獲取報銷者姓名
        if (
          newExpendituresData.value.user_id &&
          props.userOptions &&
          props.userOptions.length > 0
        ) {
          const selectedUser = props.userOptions.find(
            (user) => user.id === newExpendituresData.value.user_id
          );
          if (selectedUser && selectedUser.name_cn) {
            displayText += ` - ${selectedUser.name_cn}`;
          }
        }
      }
      // 供應商支出類型 (T開頭)
      else if (expenseNumber && expenseNumber.startsWith("T")) {
        // 獲取供應商名稱
        // 注意：目前這個組件主要用於薪金支出，供應商支出可能在其他組件中處理
        // 如果需要支援供應商支出，需要添加相應的 props 和數據源
        if (newExpendituresData.value.supplier_id && props.supplierOptions) {
          const selectedSupplier = props.supplierOptions.find(
            (supplier) => supplier.id === newExpendituresData.value.supplier_id
          );
          if (selectedSupplier && selectedSupplier.name) {
            displayText += ` - ${selectedSupplier.name}`;
          }
        }
      }

      return displayText;
    });

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newExpendituresData,
      calTotalAmount,
      calActualSalary,
      handleMainUserChange,
      handleSalaryRecordUserChange,
      handleDailySalaryTotalChange,
      handleMpfFieldChange,
      handleNumericFieldChange,
      dailySalarySummary,
      formatCurrency,
      // formattedActualSalary,
      // formattedTotalAmount,
      monthPickerConfig,
      multiDatePickerConfig,
      rangeDatePickerConfig,
      salaryUsersOptions,
      isDailySalaryType,
      expenditureDisplayText,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "~flatpickr/dist/plugins/monthSelect/style.css";
</style>

<style lang="scss" scoped>
.salary-summary-card {
  border: 1px solid #d4e6b7;
  border-radius: 8px;
  background-color: #f0ffc2;

  .summary-item {
    display: flex;
    // justify-content: ;
    align-items: center;
    padding: 4px 0;

    .summary-label {
      color: #495057;
      font-size: 0.9rem;
    }

    .summary-value {
      color: #28a745;
      font-size: 0.95rem;

      &.text-primary {
        color: #007bff !important;
        font-size: 1rem;
      }

      &.text-success {
        color: #28a745 !important;
        font-size: 1rem;
        font-weight: bold !important;
      }
    }
  }
}
</style>

